const orderState = {
    loader: false,
    OrderSuccessMessage: "",
    OrderErrorMessage: "",
    allOrders: [],
    parPage: 0,
    orderCount: 0,
  };
  
  export const OrderReducer = (state = orderState, action) => {
    const { payload, type } = action;
  
    if (type === "ORDER_SET_LOADER") {
      return {
        ...state,
        loader: true,
      };
    }
    if (type === "ORDER_ADD_SUCCESS") {
      return {
        ...state,
        loader: false,
        OrderSuccessMessage: payload.successMessage,
        OrderErrorMessage: "",
      };
    }
    if (type === "ORDER_ADD_FAIL") {
        return {
          ...state,
          loader: false,
          OrderSuccessMessage: "",
          OrderErrorMessage: payload
        };
      }
  


   
    if (type === "PERPAGE_ORDER_GET_SUCCESS") {
      return {
        ...state,
        allOrders: payload.allOrder,
        parPage: payload.parPage,
        orderCount : payload.orderCount
      };
    }
  
    if(type === "ORDER_DELETE_SUCCESS"){
      return {
        ...state,
        OrderSuccessMessage: payload,
        OrderErrorMessage: "",
      }
    }
  
    return state;
  };
  